// extracted by mini-css-extract-plugin
export default {"onboardingButton":"OnboardingToggle_onboardingButton__E9VmY"};